/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BrandDocuments } from './brandDocuments';


export interface GetBrandSettingsResponseDto { 
    shortName: string;
    appStoreLink: string;
    googlePlayLink: string;
    ruStoreLink?: string;
    documents: Array<BrandDocuments>;
    loginScreenTitle: string;
    loginScreenDescription: string;
    logo: string;
    headerLogo: string;
    logoDark?: string;
    headerLogoDark?: string;
    privacyPolicyLink: string;
    botName?: string;
    botId?: number;
    darkThemeByDefault: boolean;
    showAssociationSwitchControl: boolean;
    defaultAssociationId?: string;
    allowUserRegistrationForm: boolean;
    /**
     * Базовый адрес внутреннего мессенджера
     */
    internalMessengerUrl?: string;
    /**
     * Признак, что captcha отключена - в этом случае true.  По-умолчанию (например в продах) captcha нужна и не отключена (false).
     */
    captchaDisabled: boolean;
    /**
     * Идентификатор сервиса Яндекс-Метрика
     */
    yandexMetrikaId?: number;
    notificationsInfoImage?: string;
    notificationsInfoText?: string;
}

